import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const flattenTree = (
  treeData: TreeNode[],
  accessor: (node: TreeNode) => TreeNode[]
): { [id: string]: TreeNode } => {
  const flattenedTree: { [id: string]: TreeNode } = {};

  const flattenNode = (node: TreeNode) => {
    flattenedTree[node.id] = node;
    const children = accessor(node);
    if (children && children.length > 0) {
      for (const child of children) {
        flattenNode(child);
      }
    }
  };

  for (const rootNode of treeData) {
    flattenNode(rootNode);
  }

  return flattenedTree;
};
